import { combineReducers } from 'redux';
export const uploadProfilePictureState = {
    hasBeenUploaded: false,
    isLoading: false,
    error: null,
};
const uploadProfilePictureReducer = (state = uploadProfilePictureState, action) => {
    switch (action.type) {
        case 'OLY_UPLOAD_PROFILE_PICTURE':
            return { ...uploadProfilePictureState, isLoading: true };
        case 'OLY_UPLOAD_PROFILE_PICTURE_SUCCESS':
            return {
                ...uploadProfilePictureState,
                hasBeenUploaded: true,
            };
        case 'OLY_UPLOAD_PROFILE_PICTURE_ERROR':
            return { ...uploadProfilePictureState, error: action.payload.error };
        case 'OLY_UPLOAD_PROFILE_PICTURE_RESET':
            return uploadProfilePictureState;
        default:
            return state;
    }
};
export const userCoreState = {
    uploadProfilePicture: uploadProfilePictureState,
};
export default combineReducers({
    uploadProfilePicture: uploadProfilePictureReducer,
});
